import { Component, OnInit,ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { PeticionesService } from '../servicios/httpservice';
import {FilterPlaneadorPipe}from '../pipes/filter-planeador.pipe';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataDBService } from '../servicios/data-db.service';
@Component({
  selector: 'app-planeador-logistica',
  templateUrl: './planeador-logistica.component.html',
  styleUrls: ['./planeador-logistica.component.css']
})
export class PlaneadorLogisticaComponent implements OnInit {


  public miga:string = 'Home';
  public titulo:string = 'Planeador'
  public strRutaHome:string = '/home' 
  public arrayAlmacen: any[] = [];
  //public DatosUsuario: DatosUsuario;
  public DatosUsuario:any;
  public elementosPorPagina = 50;
  public paginaActual = 1;
  public planeadorv: boolean = true;
  public arrayPlaneador: any[];
  public arrayListadoAlmacenes: any[];
  public almacenOrigen: number = -1;
  public almacenDestino: number = -1;
  public strMesAlm: number = 1;
  public arrayFabricante: any[];
  public arrayLinea: any[];
  public strFabricante: string;
  public strLinea: string;
  public strMes: number;
  public strMesSeleccionado: string;
  public totalpaginas: number;
  public arrayTotales: any;
  public intCompras: number = -1;
  public intOpcion: number = 1;
  public sumasTotales: any = {};
  //ARRAY RESULTADOS
  public arrayEncabezados: any[];
  public ArrayResultado: any[];
  public dblCantidadResultados: number;
  public dblSumaResultados: number;
  public dblMedia: number;
  public dblCantElevado: number;
  public dblDesvEstandarRes: number;
  public dblDesvEstandar: number;
  public arrayDatosPlaneador: any;
  public arrayEncabezado: any;
  public arrayEncabezadosDatos: any;
  public arrayLineas: any;
  public resultfilter: any;
  public filteredArray: any[];
  public arrayCompras: any[];
  public arrayMeses: any = [
    { value: -1, texto: 'Seleccione' },
    { value: 1, texto: '1' },
    { value: 1.5, texto: '1.5' },
    { value: 2, texto: '2' },
    { value: 2.5, texto: '2.5' },
    { value: 3, texto: '3' },
    { value: 3.5, texto: '3.5' },
    { value: 4, texto: '4' },
    { value: 4.5, texto: '4.5' },
    { value: 5, texto: '5' },
    { value: 5.5, texto: '5.5' },
    { value: 6, texto: '6' }
  ];
  //orders
  public totalFaltante: number = 0;
  public totalExcedente: number = 0;
  public totales: number = 0;
  public orderArticulo: number = 0;
  public strAlm_Origen: string = '1';
  public strAlm_destino: string = '2';
  //FILTRO SIMPLE
  public strbuscar: string = "";
  public intComprasK: number = -1;
  public intMesK: number = -1;
  public intComprasT: number = -1;
  public intMesT: number = -1;
  public intComprasB: number = -1;
  public intMesB: number = -1;
  public arrayAccesos:any=[];
  public tagName:any;



  filterData = "";
  public spiner: boolean = false;//private localSt:LocalStorageService,
  
  constructor(private indexedDBService: DataDBService,private _httpService: PeticionesService, private router: Router,
    elem: ElementRef,private modal: NgbModal, private filterPlaneador: FilterPlaneadorPipe) {

  this.tagName = elem.nativeElement.tagName.toLowerCase();
    this.indexedDBService.getItem('arrayResult', (value) => {
      this.arrayAccesos=value?value:[];
      console.log(this.arrayAccesos[0])
      this.DatosUsuario = this.arrayAccesos[0]
    if (this.arrayAccesos.length > 0) {
      console.log(this.arrayAccesos[0])
      this.DatosUsuario = this.arrayAccesos[0]
     // this.DatosUsuario.strUsuario = "lgomez"
     }
     else {
      this.router.navigate(['/login']);
     }
    });


    this.arrayPlaneador = [];
    this.arrayListadoAlmacenes = [];
    this.arrayFabricante = [];
    this.arrayLinea = [];
    this.strMesSeleccionado = '';
    this.totalpaginas = 0;
    this.arrayEncabezados = [];
    this.ArrayResultado = [];
    this.dblCantidadResultados = 0;
    this.dblSumaResultados = 0;
    this.dblMedia = 0;
    this.dblCantElevado = 0;
    this.dblDesvEstandarRes = 0;
    this.dblDesvEstandar = 0;
    this.filteredArray = [];
    this.arrayCompras = [];
    this.strFabricante = '';
    this.strLinea = '';
    this.strMes = 1;
  }

  ngOnInit(): void {
    //
    this.arrayCompras = [{ value: -1, texto: 'Seleccione' }, { value: 1, texto: 'Con Compras' }, { value: 0, texto: 'Sin Compras' }];
    // this.intCompras = this.localSt.retrieve('intCompras')?this.localSt.retrieve('intCompras'):0;
    console.log(this.intCompras);

    console.log('inicia init')

    this.fnArraystrlinea();
    this.fngetOrigenDestino();
    this.fnGetArrayAlmacenes();

    this.arrayPlaneador = [
      { strArticulo: 'Art 01', strDescripcion: 'DES01', dblTotalF: '200', dblTotalE: '180', ALM1: '-190', ALM1P: '6.83333', ALM2: '450', ALM2P: '5.4', ALM3: '780', ALM3P: '3.8', ALM4: '333', ALM4P: '8.545612', ALM5: '-789', ALM5P: '7.4', ALM7: '-789', ALM7P: '7.4', ALM8: '-789', ALM8P: '7.4' },
      { strArticulo: 'Art 02', strDescripcion: 'DES02', dblTotalF: '350', dblTotalE: '220', ALM1: '460', ALM1P: '5.43333', ALM2: '330', ALM2P: '3.6', ALM3: '-780', ALM3P: '4.5', ALM4: '850', ALM4P: '9.1', ALM5: '852', ALM5P: '6.3', ALM7: '-789', ALM7P: '7.4', ALM8: '-789', ALM8P: '7.4' },
      { strArticulo: 'Art 03', strDescripcion: 'DES03', dblTotalF: '480', dblTotalE: '318', ALM1: '320', ALM1P: '3.33333', ALM2: '-640', ALM2P: '1.6', ALM3: '0', ALM3P: '9.777777', ALM4: '4000', ALM4P: '7.47456', ALM5: '753', ALM5P: '3.1', ALM7: '-789', ALM7P: '7.4', ALM8: '-789', ALM8P: '7.4' },
      { strArticulo: 'Art 04', strDescripcion: 'DES04', dblTotalF: '123', dblTotalE: '410', ALM1: '36', ALM1P: '7.93333', ALM2: '789', ALM2P: '6.7', ALM3: '463', ALM3P: '1.2', ALM4: '789', ALM4P: '9.8', ALM5: '125', ALM5P: '7.4', ALM7: '-789', ALM7P: '7.47777', ALM8: '-789', ALM8P: '7.4' },
      { strArticulo: 'Art 05', strDescripcion: 'DES05', dblTotalF: '654', dblTotalE: '852', ALM1: '14', ALM1P: '7.4333', ALM2: '777', ALM2P: '3.4', ALM3: '326', ALM3P: '8.2', ALM4: '-188', ALM4P: '6.478888', ALM5: '0', ALM5P: '8.3', ALM7: '-789', ALM7P: '7.4', ALM8: '-789', ALM8P: '7.4' },
      { strArticulo: 'Art 06', strDescripcion: 'DES06', dblTotalF: '654', dblTotalE: '852', ALM1: '14', ALM1P: '7.4333', ALM2: '777', ALM2P: '3.4', ALM3: '326', ALM3P: '8.2', ALM4: '-188', ALM4P: '6.478888', ALM5: '0', ALM5P: '8.3', ALM7: '-789', ALM7P: '7.4', ALM8: '-789', ALM8P: '7.4' },
      { strArticulo: 'Art 07', strDescripcion: 'DES07', dblTotalF: '654', dblTotalE: '852', ALM1: '14', ALM1P: '7.4333', ALM2: '777', ALM2P: '3.4', ALM3: '326', ALM3P: '8.2', ALM4: '-188', ALM4P: '6.478888', ALM5: '0', ALM5P: '8.3', ALM7: '-789', ALM7P: '7.4', ALM8: '-789', ALM8P: '7.4' },
    ];

    this.arrayListadoAlmacenes = [
      { strAlmacen: '1', strNombreAlm: 'Primer SK' },
      { strAlmacen: '2', strNombreAlm: 'Segundo PL' },
      { strAlmacen: '3', strNombreAlm: 'Tercer IR' },
      { strAlmacen: '4', strNombreAlm: 'Cuarto EP' },
      { strAlmacen: '5', strNombreAlm: 'Quinto DP' },
      { strAlmacen: '6', strNombreAlm: 'Sexto ES' },
      { strAlmacen: '7', strNombreAlm: 'Septimo MB' },
      { strAlmacen: '8', strNombreAlm: 'Octavo WA' },
    ];


    ///ARRAY RESULTADOS
    this.ArrayResultado = [
      { strMes: '1', dblResultado: 33, dblMedia: 0, dblRmM: 0, dblRmMe2: 0, dblSumRmMe2: 0, dblRmMe2eMm1e2: 0 },
      { strMes: '2', dblResultado: 63, dblMedia: 0, dblRmM: 0, dblRmMe2: 0, dblSumRmMe2: 0, dblRmMe2eMm1e2: 0 },
      { strMes: '3', dblResultado: 48, dblMedia: 0, dblRmM: 0, dblRmMe2: 0, dblSumRmMe2: 0, dblRmMe2eMm1e2: 0 },
      { strMes: '4', dblResultado: 12, dblMedia: 0, dblRmM: 0, dblRmMe2: 0, dblSumRmMe2: 0, dblRmMe2eMm1e2: 0 },
      { strMes: '5', dblResultado: 18, dblMedia: 0, dblRmM: 0, dblRmMe2: 0, dblSumRmMe2: 0, dblRmMe2eMm1e2: 0 },
      { strMes: '6', dblResultado: 44, dblMedia: 0, dblRmM: 0, dblRmMe2: 0, dblSumRmMe2: 0, dblRmMe2eMm1e2: 0 },
    ];
    this.dblCantidadResultados = 0;
    this.dblSumaResultados = 0;
    this.dblMedia = 0;
    this.dblCantElevado = 0;
    this.dblDesvEstandarRes = 0;
    this.dblDesvEstandar = 0;
    this.filterData = '';


  }

  seleccionarValor(event: any) {
    this.intCompras = parseInt(event.target.value, 10);


    //  this.localSt.store('intCompras',this.intCompras );
  }
  fnCambiaAlmdest(strAlm_destino:string) {
    this.strAlm_destino = strAlm_destino;
  }
  fngetOrigenDestino() {
    this.arrayEncabezado = [];
    this._httpService.getLogisticaPlaneador({
      strAccion: 'getAlmacenF',
      strAlm_Origen: this.intOpcion == 2 ? this.strAlm_Origen : '',
      strAlm_destino: this.intOpcion == 2 ? this.strAlm_destino : ''
    }).subscribe(
      resultados => {
        this.arrayEncabezado = resultados;// resultados.sort((x, y) => x.strNombreAlm.localeCompare(y.strNombreAlm));

      });
  }
  formatDescripcion(descripcion: string, linea: string): string {
    // Agregar el salto de línea en la posición deseada
    const posicionSalto = Math.floor(descripcion.length / 2);
    const descripcionFormateada = `<b>${linea}:</b> ${descripcion.slice(0, posicionSalto)}<br>${descripcion.slice(posicionSalto)}`;
    return descripcionFormateada;
  }
  getTotalPaginas(): number {
    if (!this.filteredArray || this.filteredArray.length === undefined) {
      this.totalpaginas = 0;

      return this.totalpaginas; // O manejar el caso en que 'this.arrayDatosPlaneador' no esté definido
    }

    this.totalpaginas = Math.ceil(this.filteredArray.length / this.elementosPorPagina);

    return this.totalpaginas;
  }
  cambioStrmes(event:Event, strDate: string) {
    let e =  event.target as HTMLInputElement;
    let mes = parseFloat(e.value);
    this.strMes = mes; //revisar aqui
    if (strDate == 'filtro') {
      this.strMes = mes;
    } else if (strDate == 'almacen') {
      this.strMesAlm = mes;
    }
  }
  filterArray() {
   this.filteredArray = this.filterPlaneador.transform(this.arrayDatosPlaneador, this.filterData);
    this.getTotalPaginas();
  }

  sumasarray() {
    this.sumasTotales = {};
    this.arrayDatosPlaneador.forEach((objeto:any) => {
      let totalAlmExcedente = 0;
      let totalAlmP = 0;
      let totalAlmFaltante = 0;
      for (const key in objeto) {
        if (key.startsWith('alM')) {
          if (!key.endsWith('P')) {
            if (objeto[key] < 0) {
              totalAlmFaltante = totalAlmFaltante + objeto[key];
            } else if (objeto[key] > 0) {
              totalAlmExcedente = totalAlmExcedente + objeto[key];
            }
          } else if (key.endsWith('P')) {
            totalAlmP += objeto[key];
          }
        }
      }
      objeto.totalAlmExcedente = totalAlmExcedente;
      objeto.totalAlmFaltante = totalAlmFaltante;
      objeto.total = totalAlmExcedente + totalAlmFaltante;
      objeto.totalAlmP = totalAlmP;
      this.spiner = false;
    });
    if (this.arrayDatosPlaneador && this.arrayDatosPlaneador.length > 0) {
      this.sumasTotales = this.arrayDatosPlaneador.reduce((suma:any, objeto:any) => {
        suma.totalAlmExcedente += objeto.totalAlmExcedente;
        suma.totalAlmFaltante += objeto.totalAlmFaltante;
        suma.total += objeto.total;
        return suma;
      }, { totalAlmExcedente: 0, totalAlmFaltante: 0, total: 0 });
    } else {
      this.sumasTotales = { totalAlmExcedente: 0, totalAlmFaltante: 0, total: 0 };
    }

    console.log(this.sumasTotales);
    console.log(this.arrayDatosPlaneador);


  }

  onElementosPorPaginaChange(): void {
    this.paginaActual = 1;
    this.filterArray()
    /* this.totalpaginas = this.getTotalPaginas(); */
  }


  seleccionaMes(mes:number) {

    if (mes != 0) {
      this.strMes = mes;
    }
  }

  abreModal(openModal:any, strArticulo: string, strOpcion: string, intAlmacen: number, strLineas: string) {
    console.log('///' + strArticulo + '///' + strOpcion + '///' + intAlmacen + '///' + strLineas)

    this.strMes = this.strLinea != 'PAPEL' && this.strLinea != 'ACCESORIOS G' && this.strLinea != 'IMPORTADO' && this.strLinea != 'QUIMICOS G' ? this.strMes :
      strLineas == 'TORK' || strLineas == 'ACCESORIOS' || strLineas == 'RUBBERMAID' || strLineas == 'QUIMICOS' ? this.intMesT :
        strLineas == 'DESPACHADORES ECODELI' || strLineas == 'BLUE TISSUE' || strLineas == 'DEGRAPACK' || strLineas == 'FOAOM' ? this.intMesB : this.intMesK;

    this.intCompras = this.strLinea != 'PAPEL' && this.strLinea != 'ACCESORIOS G' && this.strLinea != 'IMPORTADO' && this.strLinea != 'QUIMICOS G' ? this.intCompras :
      strLineas == 'TORK' || strLineas == 'ACCESORIOS' || strLineas == 'RUBBERMAID' || strLineas == 'QUIMICOS' ? this.intComprasT :
        strLineas == 'DESPACHADORES ECODELI' || strLineas == 'BLUE TISSUE' || strLineas == 'DEGRAPACK' || strLineas == 'FOAOM' ? this.intComprasB : this.intComprasK;

    let objeto = {
      strAccion: 'getDetalleExc_Falt',
      strArticulo: strArticulo,
      strOpcion: strOpcion,
      intAlmacen: intAlmacen,
      strLinea: strLineas,
      strUsuario: this.DatosUsuario.strUsuario
    }
    console.log(objeto);
    console.log(strLineas);
    this._httpService.getLogisticaPlaneador(objeto).subscribe(
      resultados => {
        this.arrayTotales = resultados;
        console.log(this.arrayTotales);
        this.modal.open(openModal, { size: 'lg' })
      });
  }

  cerrarModal() {
    this.modal.dismissAll();
  }

  CalculaDatos() {
    this.dblCantidadResultados = this.ArrayResultado.length;
    this.dblSumaResultados = 0;
    this.dblMedia = 0;
    this.dblCantElevado = 0;
    this.dblDesvEstandarRes = 0;
    this.dblDesvEstandar = 0;

    var indicador = 0;
    var indicadorT = 0;

    //CALCULAMOS LA SUMA DE LOS RESULTADOS Y LA MEDIA
    this.ArrayResultado.forEach(resultados => {
      this.dblSumaResultados = this.dblSumaResultados + resultados.dblResultado;
      var Media = this.dblSumaResultados / this.dblCantidadResultados;
      this.dblMedia = Media;
      indicador++
    });

    //REALIZAMOS LA RESTA DE (Resultado - Media) Y VALOR ELEVADO AL 2
    if (this.dblCantidadResultados == indicador) {
      this.ArrayResultado.forEach(totales => {
        this.ArrayResultado[indicadorT].dblMedia = this.dblMedia;
        this.ArrayResultado[indicadorT].dblRmM = totales.dblResultado - this.dblMedia;

        this.ArrayResultado[indicadorT].dblRmMe2 = Math.pow(totales.dblRmM, 2);

        //SUMA DE VALOR ELEVADO AL 2
        this.dblCantElevado = this.dblCantElevado + totales.dblRmMe2;

        indicadorT++

      });

    }

    //SE REALIZA LA DIVISION DEL RESULTADO DE LA SUMA DE LAS DIFERENCIAS ENTRE EL NUMERO DE MESES MENOS 1
    this.dblDesvEstandarRes = this.dblCantElevado / (this.dblCantidadResultados - 1);
    //SE CALCULA LA RAÍZ CUADRADA
    this.dblDesvEstandar = Math.sqrt(this.dblDesvEstandarRes);
  }

  cargarPlaneador() {
    this.spiner = true;
    let objParams ={
      strAccion: 'getEstadoPlaneador',
      strLinea: this.intOpcion == 1 ? this.strLinea : '',
      strUsuario: this.DatosUsuario.strUsuario,
      intCompras: this.intCompras,// 1.-CON COMPRAS, 0.- SIN COMPRAS
      strAlm_Origen: this.intOpcion == 2 ? this.strAlm_Origen : '',
      strAlm_destino: this.intOpcion == 2 ? this.strAlm_destino : ''
    }
    this._httpService.getLogisticaPlaneador(objParams).subscribe(
      result => {
        this.arrayDatosPlaneador = result;
        this.onElementosPorPaginaChange();
        this.sumasarray();
      });
    /*this._httpService.getLogisticaPlaneador({strAccion:'getAlmacenF'}).subscribe(
      resultados => {
        this.arrayEncabezado =resultados;
        });  */
  }

  fnGetArrayAlmacenes() {
    this.arrayAlmacen = [];

    this._httpService.getLogisticaPlaneador({ strAccion: 'getNombresAlmacen' }).subscribe(
      resultados => {
        this.arrayAlmacen = resultados;
      });
  }
  fnFiltroMes() {
    this.fngetOrigenDestino();
    this.resultfilter = [];
    this.spiner = true;
    let obj = {
      strAccion: 'getPlaneador_Suavizado', //,
      intMes: this.intOpcion == 1 ? this.strMes : this.strMesAlm,
      strLinea: this.strLinea,//this.intOpcion==1?this.strLinea:'',
      strUsuario: 'lgomez',
      intCompras: this.intCompras,// 1.-CON COMPRAS, 0.- SIN COMPRAS
      strAlm_Origen: this.intOpcion == 2 ? this.strAlm_Origen : '',
      strAlm_destino: this.intOpcion == 2 ? this.strAlm_destino : ''
    };
    console.log(obj);
    this._httpService.getLogisticaPlaneador(obj).subscribe(
      resultados => {
        console.log(resultados);
        this.resultfilter = resultados;
        if (this.resultfilter[0].code == 200) {

          this.cargarPlaneador();

        } else {
          Swal.fire({
            icon: 'error',
            title: 'Datos Incorrectos',
            text: 'Hubo un error en la conexión, intente de nuevo por favor'
          });

        }
      });
  }
  fnArraystrlinea() {
    this._httpService.getLogisticaPlaneador({ strAccion: 'getLineas' }).subscribe(
      resultados => {
        this.arrayLineas = resultados;
        this.strLinea = this.arrayLineas[0].strLinea;
        this.arrayLineas.push({ strLinea: 'PAPEL' })
        this.arrayLineas.push({ strLinea: 'ACCESORIOS G' })
        this.arrayLineas.push({ strLinea: 'IMPORTADO' })
        this.arrayLineas.push({ strLinea: 'QUIMICOS G' })
        this.arrayLineas.sort((x:any, y:any) => x.strLinea.localeCompare(y.strLinea));
        this.fnFiltroMes();
      });
  }
  fnIrTransitos() {
    this.strLinea = this.strLinea == '-1' ? '' : this.strLinea;
    // this.router.navigate(['/transitos'], { queryParams: { linea: this.strLinea,opcion:this.intOpcion, origen:this.strAlm_Origen,destino:this.strAlm_destino }});
    const queryParams = {
      linea: this.strLinea,
      opcion: this.intOpcion,
      origen: this.strAlm_Origen,
      destino: this.strAlm_destino
    };

    const url = this.router.createUrlTree(['/transitos'], { queryParams }).toString();
    console.log( url)
    window.open( url, '_blank');
  }
  fnIrReporteFaltantes(strAlmacen:string) {
    this.strLinea = this.strLinea == '-1' ? '' : this.strLinea;
    // this.router.navigate(['/transitos'], { queryParams: { linea: this.strLinea,opcion:this.intOpcion, origen:this.strAlm_Origen,destino:this.strAlm_destino }});
    const queryParams = {
      strAlmacen: strAlmacen
    };

    const url = this.router.createUrlTree(['/reporteExcedentes'], { queryParams }).toString();
    console.log( url)
    window.open( url, '_blank');
  }
  fnIrReglas( ){
    const url = this.router.createUrlTree(['/reglasPlaneador'], { }).toString();
    console.log(+ url)
    window.open( url, '_blank');
  }
  
  fnIrCompras(opcion: number) { //opcion es 1 para considerar faltantes con distribucion nacional, es 2 para faltantes sin distribucion
    let url2 = this.router.createUrlTree(['/comprasPlaneador'], { queryParams: { linea: this.strLinea, opcion: opcion } }).toString();
    window.open( url2, '_blank');
    //this.router.navigate(['/comprasPlaneador'], { queryParams: { linea: this.strLinea }});
  }
  fnmostrararray() {
    console.log(this.arrayDatosPlaneador)
  }

  funOrdenar(tipoTotal: string, strIcono: number) {
    if (tipoTotal == 'totalExcedente') {
      if (strIcono == 1) {
        this.arrayDatosPlaneador.sort((a:any, b:any) => b.totalAlmExcedente - a.totalAlmExcedente);
        this.totalExcedente = 0;
      }
      else if (strIcono == 0) {
        this.arrayDatosPlaneador.sort((a:any, b:any) => a.totalAlmExcedente - b.totalAlmExcedente);
        this.totalExcedente = 1;
      }
    }
    else if (tipoTotal == 'totalFaltante') {
      if (strIcono == 1) {
        this.arrayDatosPlaneador.sort((a:any, b:any) => b.totalAlmFaltante - a.totalAlmFaltante);
        this.totalFaltante = 0;
      }
      else if (strIcono == 0) {
        this.arrayDatosPlaneador.sort((a:any, b:any) => a.totalAlmFaltante - b.totalAlmFaltante);
        this.totalFaltante = 1;
      }
    }
    else if (tipoTotal == 'totales') {
      if (strIcono == 1) {
        this.arrayDatosPlaneador.sort((a:any, b:any) => b.total - a.total);
        this.totales = 0;
      }
      else if (strIcono == 0) {
        this.arrayDatosPlaneador.sort((a:any, b:any) => a.total - b.total);
        this.totales = 1;
      }
    } else if (tipoTotal == 'articulo') {
      if (strIcono == 1) {
        this.arrayDatosPlaneador.sort((a:any, b:any) => a.strArticulo.localeCompare(b.strArticulo));
        this.orderArticulo = 0;
      } else if (strIcono == 0) {
        this.arrayDatosPlaneador.sort((a:any, b:any) => b.strArticulo.localeCompare(a.strArticulo));
        this.orderArticulo = 1;
      }
    }
  }



  yourFn(opcion: number) {
    this.intOpcion = opcion;
    console.log(this.intOpcion)
  }

  fnFiltroPapel() {
    let arrayPapel = [
      {
        strlinea: this.strLinea == "PAPEL" ? "TORK" : this.strLinea == "ACCESORIOS G" ? "ACCESORIOS" : this.strLinea == "IMPORTADO" ? "RUBBERMAID" : this.strLinea == "QUIMICOS G" ? "QUIMICOS" : "",
        intCompras: this.intComprasT,
        intMes: this.intMesT
      }, {
        strlinea: this.strLinea == "PAPEL" ? "BLUE TISSUE" : this.strLinea == "ACCESORIOS G" ? "DESPACHADORES ECODELI" : this.strLinea == "IMPORTADO" ? "DEGRAPACK" : this.strLinea == "QUIMICOS G" ? "FOAOM" : "",
        intCompras: this.intComprasB,
        intMes: this.intMesB
      }];

    if (this.strLinea == "PAPEL") {
      arrayPapel.push({
        strlinea: "KIMBERLY",
        intCompras: this.intComprasK,
        intMes: this.intMesK
      });
    }
    let obj = {
      strAccion: 'getPlaneador_Suavizado_Papel', 
      xmlLineas: arrayPapel, strUsuario: this.DatosUsuario.strUsuario
    }
    console.log(obj);
    this._httpService.getLogisticaPlaneador(obj).subscribe(
      resultados => {
        console.log(resultados);
        this.resultfilter = resultados;
        if (this.resultfilter[0].code == 200) {
          this.cargarPlaneador();
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Datos Incorrectos',
            text: 'Hubo un error en la conexión, intente de nuevo por favor'
          });
        }
      });
  }
  fntransitosGen() {
    let url2 = this.router.createUrlTree(['/transitosGenerados'], {}).toString();
    window.open( url2, '_blank');

  }
}

